export default function DateSeparator({ date }: { date: string }) {
  const d = new Date(date)
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  let label: string
  if (d.toDateString() === today.toDateString()) {
    label = 'Сегодня'
  } else if (d.toDateString() === yesterday.toDateString()) {
    label = 'Вчера'
  } else {
    label = d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
  }

  return (
    <div className="flex items-center gap-3 my-4">
      <div className="flex-1 h-px bg-neutral-300/60" />
      <span className="text-xs text-neutral-500 font-medium whitespace-nowrap">{label}</span>
      <div className="flex-1 h-px bg-neutral-300/60" />
    </div>
  )
}
